export default __webpack_public_path__ + "static/media/u16.f52951cb.png";